/*
  RDM Mini Cart — desktop hover preview.
  Brand new, standalone file. Does not modify cart.js, cart-drawer.js, or cart-addon.js.

  rdm-mini-cart.liquid is a SNIPPET (header.liquid is itself a section, and Shopify
  does not allow nesting {% section %} inside another section — so the usual
  ?section_id= re-render trick isn't available here). Instead this fetches cart.json
  (the same AJAX endpoint cart-drawer.js already uses for the header badge count) and
  rebuilds the item list + totals directly, whenever the theme's existing cartUpdate
  pub/sub event fires.
*/
(function () {
  var POPOVER_ID = "RdmMiniCart";
  var DESKTOP_QUERY = "(min-width: 1024px)";
  var CLOSE_DELAY = 150;
  var RDM_ADDON_VARIANT_IDS = ["54587507409164", "54588486287628", "54587547713804"];

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function init() {
    var popover = document.getElementById(POPOVER_ID);
    var icons = document.querySelectorAll(".m-cart-icon-bubble");
    if (!popover || !icons.length) return;

    popover.classList.add("rdm-mini-cart--ready");

    var closeTimer = null;
    var isDesktop = function () {
      return window.matchMedia && window.matchMedia(DESKTOP_QUERY).matches;
    };

    function position(anchor) {
      var rect = anchor.getBoundingClientRect();
      popover.style.top = rect.bottom + 8 + "px";
      popover.style.right = Math.max(8, window.innerWidth - rect.right) + "px";
      popover.style.left = "auto";
    }

    function open(anchor) {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      position(anchor);
      popover.classList.add("rdm-mini-cart--open");
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        popover.classList.remove("rdm-mini-cart--open");
      }, CLOSE_DELAY);
    }

    icons.forEach(function (icon) {
      icon.addEventListener("mouseenter", function () { open(icon); });
      icon.addEventListener("mouseleave", scheduleClose);
    });

    popover.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
    popover.addEventListener("mouseleave", scheduleClose);

    window.addEventListener("resize", function () {
      if (!isDesktop()) popover.classList.remove("rdm-mini-cart--open");
    });

    function itemRowHtml(item) {
      var hasDiscount = item.original_line_price !== item.final_line_price;
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_96x96$1$2") + '" alt="" loading="lazy" width="44" height="44">' : "";
      return (
        '<div class="rdm-mini-item" data-rdm-mini-item data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="rdm-mini-item__thumb">' + img + '</a>' +
          '<div class="rdm-mini-item__body">' +
            '<a href="' + item.url + '" class="rdm-mini-item__title">' + item.product_title + '</a>' +
            '<div class="rdm-mini-item__stepper">' +
              '<button type="button" class="rdm-mini-qty__btn" data-rdm-mini-qty-minus' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
              '<span class="rdm-mini-qty__value" data-rdm-mini-qty-value>' + item.quantity + '</span>' +
              '<button type="button" class="rdm-mini-qty__btn" data-rdm-mini-qty-plus>+</button>' +
            '</div>' +
          '</div>' +
          '<div class="rdm-mini-item__price">' +
            (hasDiscount ? '<s>' + fmt(item.original_line_price) + '</s>' : '') +
            fmt(item.final_line_price) +
          '</div>' +
        '</div>'
      );
    }

    function changeQuantity(key, quantity) {
      return fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }

    function bindItemEvents(itemsBox) {
      itemsBox.querySelectorAll("[data-rdm-mini-item]").forEach(function (row) {
        var key = row.dataset.key;
        var minus = row.querySelector("[data-rdm-mini-qty-minus]");
        var plus = row.querySelector("[data-rdm-mini-qty-plus]");
        var valueEl = row.querySelector("[data-rdm-mini-qty-value]");

        function update(delta) {
          var next = parseInt(valueEl.textContent, 10) + delta;
          if (next < 1) return;
          if (minus) minus.disabled = true;
          if (plus) plus.disabled = true;
          changeQuantity(key, next)
            .then(function (cart) {
              render(cart);
              if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
                window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: "rdm-mini-cart" });
              }
            })
            .catch(function () {
              if (minus) minus.disabled = false;
              if (plus) plus.disabled = false;
            });
        }

        if (minus) minus.addEventListener("click", function () { update(-1); });
        if (plus) plus.addEventListener("click", function () { update(1); });
      });
    }

    function render(cart) {
      var itemsBox = popover.querySelector("[data-rdm-mini-items]");
      var countLabel = popover.querySelector("[data-rdm-mini-count]");
      var foot = popover.querySelector("[data-rdm-mini-foot]");
      if (!itemsBox) return;

      var visibleItems = cart.items.filter(function (item) {
        return RDM_ADDON_VARIANT_IDS.indexOf(String(item.variant_id)) === -1;
      });

      if (countLabel) countLabel.textContent = cart.item_count + " ks";

      if (!visibleItems.length) {
        itemsBox.innerHTML = '<div class="rdm-mini-cart__empty">' + (itemsBox.dataset.emptyText || "") + '</div>';
        if (foot) foot.style.display = "none";
        return;
      }

      itemsBox.innerHTML = visibleItems.map(itemRowHtml).join("");
      bindItemEvents(itemsBox);

      var subtotal = visibleItems.reduce(function (sum, item) { return sum + item.original_line_price; }, 0);
      var discount = subtotal - cart.total_price;
      var points = Math.floor(cart.total_price / 10);

      if (foot) {
        foot.style.display = "";
        var rows = foot.querySelectorAll(".rdm-mini-cart__row");
        if (rows[0]) rows[0].querySelector("span:last-child").textContent = fmt(subtotal);
        var discountRow = foot.querySelector(".rdm-mini-cart__row--discount");
        var totalRow = foot.querySelector(".rdm-mini-cart__row--total");
        if (discount > 0) {
          if (!discountRow) {
            discountRow = document.createElement("div");
            discountRow.className = "rdm-mini-cart__row rdm-mini-cart__row--discount";
            discountRow.innerHTML = "<span></span><span></span>";
            foot.insertBefore(discountRow, totalRow);
          }
          discountRow.style.display = "";
          discountRow.querySelector("span:last-child").textContent = "−" + fmt(discount);
        } else if (discountRow) {
          discountRow.style.display = "none";
        }
        if (totalRow) totalRow.querySelector("span:last-child").textContent = fmt(cart.total_price);
        var points_el = foot.querySelector(".rdm-mini-cart__points");
        if (points_el) {
          points_el.textContent = points_el.textContent.replace(/[+−-]?\d+(?=\s*bodov)/, "+" + points);
        }
      }
    }

    function refresh() {
      fetch(window.Shopify.routes.root + "cart.json")
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, refresh);
    }

    // bind the server-rendered rows present on first page load (render() only
    // binds rows it rebuilds itself after an AJAX refresh)
    var initialItemsBox = popover.querySelector("[data-rdm-mini-items]");
    if (initialItemsBox) bindItemEvents(initialItemsBox);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();